import React, { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import Milestone from '../../../components/Inputs/MileStone';
import { actualValueForDropdown, ScogoID } from '../../../utils/common';
import { motion } from 'framer-motion';
import { useSelector } from 'react-redux';

const MilestoneFields = ({ title, type, setProjectMilestones, index, id }) => {
    const formContext = useFormContext();
    const watch = formContext.watch;
    const selectedOrganization = watch('organization');
    const selectedProject = watch('project');
    const newLoggedUserData = useSelector((state) => state.auth.newLoggedUserData);

    const handleRemoveMilestone = () => {
        setProjectMilestones(prevMilestones =>
            prevMilestones.filter(milestone => milestone.id !== id)
        );
    };

    const canEditIncentivePricing = useMemo(() => {
        return newLoggedUserData.org.id === ScogoID;
    }, [newLoggedUserData.org.id]);

    return (
        <motion.div
            className='rounded-lg bg-gray-100 px-6 py-3 transition-transform transform hover:scale-105'
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
        >
            <div className='flex justify-between items-center border-b-2 border-scogoprimary pb-2'>
                <p className='text-lg font-semibold text-scogoprimary pb-2'>{title}</p>
                {id && id.startsWith('new_') && <button
                    type="button"
                    onClick={handleRemoveMilestone}
                    className="text-gray-500 hover:text-gray-700"
                >
                    <span className="material-icons-outlined" style={{ fontSize: '16px' }}>close</span>
                </button>}
            </div>
            <div className='grid grid-cols-3 pb-4 pt-4'>
                <Milestone
                    id={id}
                    onChange={(value, event, id) => {
                        if (id && id.startsWith('new_')) {
                            setProjectMilestones((prev) => {
                                const findIndex = prev.findIndex((elem) => elem.id === id);
                                if (findIndex !== -1) {
                                    prev[findIndex] = { ...event.milestone, title: `Milestone${index + 1}`, id };
                                }
                                return prev;
                            });
                        }
                    }}
                    name={`milestone-${type}-${index}`}
                    label='Milestone'
                    org_id={actualValueForDropdown(selectedOrganization)}
                    addNew
                    prefill={type}
                    selectedProject={selectedProject}
                    canEditVendorPricing={canEditIncentivePricing}
                    canEditIncentivePricing={canEditIncentivePricing}
                />
            </div>
        </motion.div>
    );
};

export default MilestoneFields;
